import React from "react";
import { Outlet } from "react-router-dom";
import { Box, CssBaseline } from "@mui/material";
import Sidebar from "./sidebar";
import Header from "./header";

const UserLayout = () => {
  return (
    <Box sx={{ display: "flex", height: "100vh" }}>
      <CssBaseline />

      {/* Sidebar - Full height on the left */}
      <Sidebar />

      {/* Main content area - Header + Content */}
      <Box sx={{ 
        display: "flex", 
        flexDirection: "column", 
        flex: 1,
        overflow: "hidden" // Prevent content overflow
      }}>
        {/* Header at the top of content area */}
        <Header />

        {/* Content area with Outlet */}
        <Box 
          component="main" 
          sx={{ 
            flex: 1, 
            p: 2, 
            overflowY: "auto",
            //backgroundColor: "#f8f9fa"
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};

export default UserLayout;